module.exports = __webpack_public_path__ + "img/icon-metamask.533e0ea8.svg";